export const FORM_TYPES = {
  consultation: 'consultation',
  musicSupport: 'music-support',
} as const

export type FormType = typeof FORM_TYPES[keyof typeof FORM_TYPES]

export const TROUBLE_OPTIONS = [
  '曲を作りたいけど何から始めたらいいかわからない',
  '誰に依頼したらいいかわからない',
  'どうやって依頼したらいいかわからない',
  'どうやってクリエイターを選んだらいいかわからない',
  '音楽制作の始め方がわからない',
  'とにかく相談したい',
] as const

export const CONSULTATION_FORMAT_OPTIONS = [
  'オンラインでの直接相談を希望',
  'メールでのテキストのやり取りを希望',
] as const
